import * as Yup from "yup";

export const nullifyFormValidation = Yup.object({
  motivoAnulacion: Yup.string().required("Campo obligatorio"),
})